import routes from './routes';
import reducer from './reducer';

export default {
    getRoutes: function() {
        return routes;
    },
    getReducers: function() {
        return reducer;
    }
};



// WEBPACK FOOTER //
// ./environments/ticketsgit/index.js